import React, { useState, useEffect } from "react";
import style from "./Items.module.scss";
import Files from "./NewPost/Files/Files";
import {
  Button,
  Badge,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  ButtonGroup,
  Row,
  Col,
  Table,
  ListGroup,
  ListGroupItem,
} from "reactstrap";

import { getPersonTypeName } from "../../AlertSimple/Fields/types";
import CircularProgress from "../../../CircularProgress/CircularProgress";
import LaddaButton, { SLIDE_DOWN, SLIDE_LEFT } from "react-ladda";
import { accountProps } from "../../Order/Form/commons";
import { getLocalDate } from "../../../../utils";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";
import InvestorProfile from "./subsummary/investorProfile";
import DuplicatedPeople from "./subsummary/duplicatedPeople";


const Summary = ({
  description,
  title,
  personType,
  typeAlias,
  files,
  relateds,
  alert,
  fetchs,
  loadingAlert,
  alertId,
  reftag,
  days,
  status,
  role,
  markFalseCoincidence,
  processes,
  requestClosure,
  name,
  closedAccountDate,
  closedAccount,
  dispatch,
  Link,
  trigger,
  personInfo,
  refId,
  antiClientDetails,
  accountsRelated,
}) => {
  const [closing, setClosing] = useState(0);
  const [loadingCloseAccount, SetLoadingCloseAccount] = useState(false);
  const [showMessageCloseAccount, SetShowMessageCloseAccount] = useState(false);
  const [sending, setROS] = useState(0);
  const [info, setInfo] = useState();
  const [updateKYCStatus, setUpdateKYCStatus] = useState(false);

  useEffect(() => {
    fetchs.getParameterValue({ParameterName:"UpdateKYCStatus"}, (response) => {
      if (response) {
        setUpdateKYCStatus(response.SdtParametersData.ParameterNumericValue == 1);
      }
  })}, [updateKYCStatus]);

  useEffect(() => {
    if (reftag && processes === "TransactionalLimit") {
      try {
        let newInfo = JSON.parse(reftag);
        setInfo(newInfo);
      } catch (e) {
        setInfo();
      }
    }
  }, [reftag]);

  const openChild = (child) => {
    dispatch({ type: "TOGGLE_CHILD_ALERT", alert: child });
  };

  const downloadPdf = () => {
    fetchs.downloadPdf({ eventId: alertId });
  };

  const checkFalseCoincidence = (falseCoincidence) => {
    const body = {
      complianceEventid: alertId,
      falseCoincidence: falseCoincidence,
    };
    fetchs.falseCoincidenceCheckList(body);
    dispatch({
      type: "CHECKLIST_COINCIDENCE",
      alert: falseCoincidence,
    });
  };

  const closeAccount = () => {
    SetLoadingCloseAccount(true);
    fetchs.closeAccountAlert(
      {
        eventId: alertId,
        accountId: typeAlias,
      },
      (response) => {
        SetLoadingCloseAccount(false);
        SetShowMessageCloseAccount(true);
      }
    );
  };

  const closeAlert = () => {
    setClosing({ loading: true });

    fetchs.updateStatus(
      {
        eventId: alertId,
        statusCompliance: "Closed",
      },
      (response) => {
        setClosing(1);

        dispatch({ type: "ALERT_UPDATE", alert: { status: "Closed" } });
      }
    );
  };

  const getJournalEntryId = (linea) => {
    const partes = linea.split(",");
    if (partes.length < 2) {
      return "";
    }
    const journalEntryId = partes[0].trim().split(":")[1].trim();
    return journalEntryId;
  };

  const alertToROS = () => {
    setROS({ loading: true });

    fetchs.updateStatus(
      {
        eventId: alertId,
        statusCompliance: "ROS",
      },
      (response) => {
        setROS(1);

        dispatch({ type: "ALERT_UPDATE", alert: { status: "ROS" } });
      }
    );
  };

  return (
    <div className={style.summary}>
      <div className={style.title}>
        <h5>
          {processes == "KYC" || processes == "Flags" || processes == "ExternalImport" || processes == "RiskChanges" ? (
            description
          ) : processes == "CheckList" || processes == "TransactionalLimit" ? (
            <div>{title}</div>
          ) : processes == "TransLimitChanges" && description ? (
            <div>{description.split(".")[0]}</div>
          ) : (
            <div>
              {getPersonTypeName(personType)}
              {": "}
              {typeAlias} {title}
            </div>
          )}
        </h5>
        <div className="text-right">
          {(status == "Closed" || closing == 1) && (
            <Button color="primary btn-sm" onClick={() => downloadPdf()}>
              <i className="fa fa-download"></i>
            </Button>
          )}
          {((status != "Closed" && status != "ROS" && closing != 1 && processes != "RiskChanges" && role == "Compliance") || (processes == "ExternalImport" && status != "Closed") || (role == "CEO" && processes == "RiskChanges" && status != "Closed")) && (
            <LaddaButton
              className={"btn btn-ladda btn-primary"}
              loading={closing.loading}
              onClick={() => closeAlert()}
              data-style={SLIDE_DOWN}
            >
              Close alert
            </LaddaButton>
          )}
        </div>
      </div>
      <div className={style.related}>
        <div className={style.left}>
          {processes === "CheckList" && (
            <div>
              <p>{`${trigger}(${reftag})`}</p>
              <strong>Details</strong>
              {(!antiClientDetails || antiClientDetails.length == 0 || antiClientDetails[0] == "") && (
                <p>No details</p>
              )}
              {antiClientDetails.length > 0 && (
                <div>
                  <ListGroup flush>
                    {antiClientDetails.map((item, index) => (
                      <ListGroupItem className="p-3" key={index}>
                        {
                          // convert to bold font the words into simple quoatation marks
                          item.split("-").map((part, index) => (
                            <span key={index}>
                              {part
                                .split(":")
                                .map((part2, index) =>
                                  part2.startsWith("'") && part2.endsWith("'") ? (
                                    <strong>{part2.replace(/'/g, "") + ":"}</strong>
                                  ) : (
                                    part2 + " "
                                  )
                                )}
                            </span>
                          ))
                        }
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                </div>
              )}
              <strong>Client</strong>
              <p>
                <Link to={`/person/${typeAlias}`} target="_blank">
                  {`${name}(${
                    personInfo.PhysicalPersonMainDocumentNumber
                      ? personInfo.PhysicalPersonMainDocumentNumber
                      : typeAlias
                  })`}
                </Link>
              </p>
              <p>{description.includes("spouse") && description}</p>
              <strong>Accounts related</strong>
              {accountsRelated.length == 0 && <p>No accounts</p>}
              {accountsRelated.length > 0 && (
                <div>
                  {accountsRelated.map((account, index) => (
                    <p key={index}>
                      <Link to={`/account/${account.AccountId}`} target="_blank">
                        {`${account.Relationship} - ${account.AccountId} - ${account.AccountName}`}
                      </Link>
                    </p>
                  ))}
                </div>
              )}
            </div>
          )}
          {(processes==="ExternalImport"&& description.includes("duplicated people")) ? (
            <div>
             <DuplicatedPeople alert={alert} fetchs={fetchs}  Link={Link} closeAlert={closeAlert} />
            </div>
          ):
          (processes=="InvestorProfile"? (
            <div>
              {processes=="InvestorProfile" && (
                <InvestorProfile investorProfile={trigger} />
              )}
            </div>
          ):    

          (
            (processes!="InvestorProfile" && processes !== "TransactionalLimit" && processes !== "CheckList" && processes != "RiskChanges") || (processes==="ExternalImport" && !description.includes("duplicated people")))&& (

            <div>
              <div>
                <strong>Data related</strong>
                {processes === "TransLimitChanges" && description ? (
                  <div>
                    <p>{"Transactional Limit Changes "}</p>
                    <p>{reftag.split("*")[0]}</p>
                    <p>{reftag.split("*")[1]}</p>
                    <p>{reftag.split("*")[2]}</p>
                    <p>
                      <LaddaButton
                        className={"btn btn-ladda btn-primary"}
                        loading={sending.loading}
                        onClick={() => alertToROS()}
                        data-style={SLIDE_LEFT}
                      >
                        Mark as ROS
                      </LaddaButton>
                    </p>
                  </div>
                ) : (
                  <p>
                    {processes === "KYC" || processes === "Flags" || reftag === "CLOSEACCOUNT"
                      ? trigger.split("--").map((linea, index) => <p key={index}>{linea}</p>)
                      : (processes == "ExternalImport" ? reftag : 
                        (processes === "Onboarding" ?
                        <Link to={`/${description.includes('Person')? 'Person' :role=="Compliance"?'account':'position'}/${refId}`} target="_blank">
                          {description}
                         </Link>
                         :description)
                      )}
                  </p>
                )}
              </div>
              {processes === "Precheck" && (
                <div>
                  <strong> Precheck Details</strong>
                  <p>{reftag}</p>
                </div>
              )}
              {(processes === "KYC" || processes === "Flags") && reftag !== "" && (
                <div>
                  <strong>Flags</strong>
                  <p>{reftag}</p>
                </div>
              )}
              {status != "Closed" &&
                status != "ROS" &&
                sending != 1 &&
                processes == "KYC" &&
                role == "Compliance" && 
                updateKYCStatus && 
                (
                  <div>
                    <LaddaButton
                      className={"btn btn-ladda btn-primary"}
                      loading={sending.loading}
                      onClick={() => alertToROS()}
                      data-style={SLIDE_LEFT}
                    >
                      KYC not approved
                    </LaddaButton>
                  </div>
                )}
            </div>
            )
          )}
        </div>

        {processes == "TransactionalLimit" && (
          <div className={style.left}>
            <strong>Details</strong>
            <p>
              {trigger.trim() == "Quantity limit in deposits" ||
              trigger.trim() == "Quantity limit in Withdraws" ||
              trigger.trim() == "Amount limit in deposits" ||
              trigger.trim() == "Amount limit in Withdraws"
                ? role == "Advisor"
                  ? reftag.split(";").map((linea, index) =>
                      linea.includes("JournalEntryId:") ? (
                        <a href={`/#/crossReference/JournalEntry/${getJournalEntryId(linea)}`}>
                          {linea} <br />
                        </a>
                      ) : (
                        <p key={index}>
                          {linea} {"\n"}{" "}
                        </p>
                      )
                    )
                  : reftag.split(";").map((linea, index) => (
                      <p key={index}>
                        {linea} {"\n"}
                      </p>
                    ))
                : trigger}
            </p>
            {info !== undefined && info !== "" ? (
              <Table className={style.table}>
                <thead>
                  <tr>
                    <th>Info</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {info.map((i) => {
                    return (
                      <tr key={`t-${i.key}`}>
                        <td>{i.key}</td>
                        <td>
                          <FormattedNumber value={i.value} decimalScale={0} />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            ) : (
              ""
            )}

            {status != "Closed" &&
              status != "ROS" &&
              sending != 1 &&
              role == "Compliance" &&
              processes !== "KYC" && (
                <LaddaButton
                  className={"btn btn-ladda btn-primary"}
                  loading={sending.loading}
                  onClick={() => alertToROS()}
                  data-style={SLIDE_LEFT}
                >
                  Mark as ROS
                </LaddaButton>
              )}
          </div>
        )}

        <span className={style.right}>
          {relateds != null && (
            <RelatedDDown relateds={relateds} openChildAlert={openChild}>
              <React.Fragment>
                <span className={style.btnRelated} disabled={relateds.length == 0}>
                  <i className="fa fa-bell"></i>
                  <Badge pill color="danger" className={style.badge}>
                    {relateds.length}
                  </Badge>
                </span>
              </React.Fragment>
            </RelatedDDown>
          )}
        </span>
      </div>
      {requestClosure ? (
        <Row style={{ marginBottom: "5px" }}>
          <Col lg={12}>
            {closedAccount ? (
              <div style={{ color: "mediumseagreen" }}>
                The account {name} is Closed - Date of closure: {getLocalDate(closedAccountDate)}
              </div>
            ) : (
              <div>
                <div>
                  <strong>Close Account</strong>
                </div>
                {showMessageCloseAccount ? (
                  <div style={{ color: "mediumseagreen" }}>The account was successfully closed</div>
                ) : (
                  <div>
                    Do you want to Close Account {name}?
                    <LaddaButton
                      style={{ float: "right" }}
                      className="btn btn-ladda btn-primary mb-2"
                      loading={loadingCloseAccount}
                      disabled={false}
                      onClick={() => closeAccount()}
                      data-style={SLIDE_LEFT}
                    >
                      Confirm
                    </LaddaButton>
                  </div>
                )}
              </div>
            )}
          </Col>
        </Row>
      ) : (
        <div />
      )}
      {processes == "CheckList" ? (
        <Row style={{ marginBottom: "5px" }}>
          <Col lg={12}>
            <div>
              <strong>Person Checklist</strong>
            </div>
            Do you want to mark this person as a false coincidence? If you select yes this alert wont be
            generated again next time
            <ButtonGroup style={{ float: "right" }}>
              <Button
                onClick={() => checkFalseCoincidence(true)}
                color={markFalseCoincidence === true ? "success btn btn-sm" : "primary btn btn-sm"}
                active={markFalseCoincidence === true}
              >
                YES
              </Button>
              <Button
                onClick={() => checkFalseCoincidence(false)}
                color={markFalseCoincidence === false ? "danger btn btn-sm" : "primary btn btn-sm"}
                active={markFalseCoincidence === false}
              >
                NO
              </Button>
            </ButtonGroup>
          </Col>
        </Row>
      ) : (
        <div></div>
      )}

      <Files
        hideDelete
        loading={loadingAlert}
        personType={personType}
        alias={typeAlias}
        fetchs={{
          downloadFile: fetchs.downloadFile,
          fileTypes: fetchs.fileTypes,
          send: fetchs.send,
        }}
        files={files}
      />
    </div>
  );
};

const RelatedDDown = ({ children, relateds, openChildAlert }) => (
  <UncontrolledDropdown>
    <DropdownToggle nav style={{ paddingRight: "0px" }}>
      {children}
    </DropdownToggle>
    {relateds.length != 0 && (
      <DropdownMenu right>
        <DropdownItem header tag="div">
          <strong>Relateds alerts</strong>
        </DropdownItem>
        {relateds &&
          relateds.map((r, i) => (
            <DropdownItem key={`rel-${r.id}-${i}`} onClick={() => openChildAlert(r)}>
              <i className="fa fa-bell text-primary"></i> {r.title} {r.description}
            </DropdownItem>
          ))}
      </DropdownMenu>
    )}
  </UncontrolledDropdown>
);

export const LoadingMessage = ({ text }) => (
  <div className={style.loadingMessage}>
    <CircularProgress sm style={{ margin: "0px" }} />
    <span>{text}</span>
  </div>
);

export default Summary;
